import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Alert, Button, Drawer, Input, Field } from '@itds/elements/index.js';

import Api from '@carrier/utils/Api';

const Edit = ({ version, onClose, onSave, show }) => {
  const [data, setData] = useState({
    id: '',
    name: '',
    notes: ''
  });

  const [save_error, setSaveError] = useState(false);

  useEffect(() => {
    const new_version = version || {};

    setData({
      id: new_version.id,
      name: new_version.name,
      notes: new_version.notes
    });
  }, [version]);

  const handleInputChange = (name, e) => {
    setData({ ...data, [name]: e.target.value });
  };

  const handleSave = () => {
    const { id, ...payload } = data;

    Api.saveLtcQuoteVersion(id, payload)
      .then(() => {
        onSave();
        setSaveError(false);
      })
      .catch(() => {
        setSaveError(true);
        setTimeout(() => {
          setSaveError(false);
        }, 2000);
      });
  };

  return (
    <Drawer
      alignRight={true}
      footer={<Button onClick={handleSave}>Save Changes</Button>}
      onClose={onClose}
      show={show}
      title='Editing Version'
    >
      {save_error ? (
        <Alert type='error'>An error occurred while trying to save the version.</Alert>
      ) : null}
      <Field label='Name'>
        <Input onChange={handleInputChange.bind(null, 'name')} value={data.name} />
      </Field>

      <Field label='Internal Notes'>
        <Input
          height={150}
          onChange={handleInputChange.bind(null, 'notes')}
          type='textarea'
          value={data.notes}
        />
      </Field>
    </Drawer>
  );
};

Edit.propTypes = {
  onClose: PropTypes.func,
  onSave: PropTypes.func,
  show: PropTypes.bool,
  version: PropTypes.object
};

export default Edit;
